import { AxiosResponse } from 'axios';

import { Admin } from '@/types/admin';
import { AdminRole, Affiliation } from '@/types/affiliation';
import { Organization } from '@/types/organization';

import { api } from '@/services/api/axios/instance';

type DeleteParams = {
  data: {
    adminId: Admin['id'];
    organizationId: Organization['id'];
  };
};

type UpdateRoleParams = {
  data: {
    role: AdminRole;
    adminId: Admin['id'];
    organizationId: Organization['id'];
  };
};

type UpdateNameParams = {
  data: {
    admin: Admin;
    organizationId: Organization['id'];
  };
};

export const affiliationsAdminApi = {
  delete: async (config: DeleteParams): Promise<void> => {
    const { organizationId, adminId } = config.data;
    const path = `organizations/${organizationId}/affiliations/admins/${adminId}`;

    await api.delete(path, config);
  },
  updateRole: async (config: UpdateRoleParams): Promise<Affiliation> => {
    const { data, ...requestConfig } = config;
    const { organizationId, adminId, role } = data;
    const path = `organizations/${organizationId}/affiliations/admins/${adminId}`;
    const params = {
      role,
    };

    const response: AxiosResponse<{
      affiliation: Affiliation;
    }> = await api.patch(path, params, requestConfig);

    return response.data.affiliation;
  },
  updateName: async (config: UpdateNameParams): Promise<Affiliation> => {
    const { data, ...requestConfig } = config;
    const { organizationId, admin } = data;
    const path = `organizations/${organizationId}/affiliations/admins/${admin.id}`;
    const params = {
      first_name: admin.firstName,
      last_name: admin.lastName,
      kana_first_name: admin.kanaFirstName,
      kana_last_name: admin.kanaLastName,
    };

    const response: AxiosResponse<{
      affiliation: Affiliation;
    }> = await api.patch(path, params, requestConfig);

    return response.data.affiliation;
  },
};
